function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { ProGallery, GALLERY_CONSTS } from 'pro-gallery'; // use blueprints

import { utils } from '../utils';

var ProGallerySlider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ProGallerySlider, _Component);

  function ProGallerySlider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.galleryEventsHandler = _this.galleryEventsHandler.bind(_assertThisInitialized(_this));
    _this.state = {
      currentIdx: _this.props.currentIdx || 0
    };
    return _this;
  }

  var _proto = ProGallerySlider.prototype;

  _proto.galleryEventsHandler = function galleryEventsHandler(eventName, eventData) {
    var actions = this.props.actions;

    switch (eventName) {
      case GALLERY_CONSTS.events.CURRENT_ITEM_CHANGED:
        actions.setCurrentItem(eventData.galleryItem);
        break;

      case GALLERY_CONSTS.events.ITEM_CLICKED:
        break;

      default:
        break;
    }
  };

  _proto.nextSlide = function nextSlide(idx) {
    var actions = this.props.actions;
    actions.next(null, idx);
  };

  _proto.getGallerySlider = function getGallerySlider() {
    var style = {
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)'
    };
    return this.props.items.length > 0 ? /*#__PURE__*/React.createElement("div", {
      style: style
    }, /*#__PURE__*/React.createElement(ProGallery, _extends({}, this.props, {
      eventsListener: this.galleryEventsHandler,
      domId: 'pro-gallery-fullscreen-wrapper',
      key: 'pro-gallery-fullscreen-wrapper',
      currentIdx: this.props.currentIdx
    }))) : null;
  };

  _proto.render = function render() {
    return this.getGallerySlider();
  };

  return ProGallerySlider;
}(Component);

export { ProGallerySlider as default };